/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient, HttpRequest, HttpResponse,
  HttpHeaders, HttpParams
} from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { filter } from 'rxjs/operators/filter';

@Injectable()
export class ManagerCompanyActivityLogsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * GET /manager/company-activity-logs/login-logout
   */
  managerLoginLogoutLogsResponse(params?: {
    from_date?: string;
    to_date?: string;
    user_id?: number;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.from_date != null) {
      __params = __params.set('from_date', params.from_date.toString());
    }
    if (params != null && params.to_date != null) {
      __params = __params.set('to_date', params.to_date.toString());
    }
    if (params != null && params.user_id != null) {
      __params = __params.set('user_id', params.user_id.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/company-activity-logs/login-logout`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerLoginLogoutLogs(params?: {
    from_date?: string;
    to_date?: string;
    user_id?: number;
  }): Observable<any> {
    return this.managerLoginLogoutLogsResponse(params).pipe(map(_r => _r.body));
  }

  /**
   * GET /manager/company-activity-logs/change-password
   */
  managerChangePasswordLogsResponse(params?: {
    from_date?: string;
    to_date?: string;
    actor_user_id?: number;
    target_user_id?: number;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.from_date != null) {
      __params = __params.set('from_date', params.from_date.toString());
    }
    if (params != null && params.to_date != null) {
      __params = __params.set('to_date', params.to_date.toString());
    }
    if (params != null && params.actor_user_id != null) {
      __params = __params.set('actor_user_id', params.actor_user_id.toString());
    }
    if (params != null && params.target_user_id != null) {
      __params = __params.set('target_user_id', params.target_user_id.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/company-activity-logs/change-password`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerChangePasswordLogs(params?: {
    from_date?: string;
    to_date?: string;
    actor_user_id?: number;
    target_user_id?: number;
  }): Observable<any> {
    return this.managerChangePasswordLogsResponse(params).pipe(map(_r => _r.body));
  }

  /**
   * GET /manager/company-activity-logs/assign-permission
   */
  managerAssignPermissionLogsResponse(params?: {
    from_date?: string;
    to_date?: string;
    actor_user_id?: number;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.from_date != null) {
      __params = __params.set('from_date', params.from_date.toString());
    }
    if (params != null && params.to_date != null) {
      __params = __params.set('to_date', params.to_date.toString());
    }
    if (params != null && params.actor_user_id != null) {
      __params = __params.set('actor_user_id', params.actor_user_id.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/company-activity-logs/assign-permission`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerAssignPermissionLogs(params?: {
    from_date?: string;
    to_date?: string;
    actor_user_id?: number;
  }): Observable<any> {
    return this.managerAssignPermissionLogsResponse(params).pipe(map(_r => _r.body));
  }

  /**
   * GET /manager/company-activity-logs/export-excel
   */
  managerExportExcelLogsResponse(params?: {
    from_date?: string;
    to_date?: string;
    actor_user_id?: number;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.from_date != null) {
      __params = __params.set('from_date', params.from_date.toString());
    }
    if (params != null && params.to_date != null) {
      __params = __params.set('to_date', params.to_date.toString());
    }
    if (params != null && params.actor_user_id != null) {
      __params = __params.set('actor_user_id', params.actor_user_id.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/company-activity-logs/export-excel`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerExportExcelLogs(params?: {
    from_date?: string;
    to_date?: string;
    actor_user_id?: number;
  }): Observable<any> {
    return this.managerExportExcelLogsResponse(params).pipe(map(_r => _r.body));
  }

  /**
   * GET /manager/company-activity-logs/export
   * Xuất Excel theo loại lịch sử + filter.
   */
  managerExportActivityLogsResponse(params?: {
    from_date?: string;
    to_date?: string;
    log_type?: string;
    user_id?: number;
    actor_user_id?: number;
    target_user_id?: number;
  }): Observable<HttpResponse<Blob>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.from_date != null) {
      __params = __params.set('from_date', params.from_date.toString());
    }
    if (params != null && params.to_date != null) {
      __params = __params.set('to_date', params.to_date.toString());
    }
    if (params != null && params.log_type != null) {
      __params = __params.set('log_type', params.log_type.toString());
    }
    if (params != null && params.user_id != null) {
      __params = __params.set('user_id', params.user_id.toString());
    }
    if (params != null && params.actor_user_id != null) {
      __params = __params.set('actor_user_id', params.actor_user_id.toString());
    }
    if (params != null && params.target_user_id != null) {
      __params = __params.set('target_user_id', params.target_user_id.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/company-activity-logs/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<Blob>;
      })
    );
  }

  managerExportActivityLogs(params?: {
    from_date?: string;
    to_date?: string;
    log_type?: string;
    user_id?: number;
    actor_user_id?: number;
    target_user_id?: number;
  }): Observable<Blob> {
    return this.managerExportActivityLogsResponse(params).pipe(map(_r => _r.body));
  }
}
